import React, { useEffect, useState } from "react";
import { usePopper } from "react-popper";
import PropTypes from "prop-types";

import { TooltipWrapper } from "./styled";

const Tooltip = ({
  childrenRef,
  tooltipLabel,
  tooltipComponent,
  placement = "bottom",
  xShift = 0
}) => {
  const [referenceEl, setReferenceEl] = useState(null);
  const [popperEl, setPopperEl] = useState(null);
  const [position, setPosition] = useState([]); // [y, x]

  let timer = null;

  const showTooltip = (event) => {
    hideTooltip();

    timer = setTimeout(() => {
      popperEl.setAttribute("data-show", true);

      setPosition([event.pageY + 35, event.pageX + xShift]);
    }, 500);
  };

  const hideTooltip = () => {
    clearTimeout(timer);
    popperEl.removeAttribute("data-show");
  };

  const { styles, attributes } = usePopper(referenceEl, popperEl, {
    placement
  });

  useEffect(() => {
    if (childrenRef && childrenRef.current && popperEl) {
      setReferenceEl(childrenRef.current);

      childrenRef.current.addEventListener("mousemove", showTooltip);
      childrenRef.current.addEventListener("mouseleave", hideTooltip);
    }

    return () => {
      if (childrenRef && childrenRef.current && popperEl) {
        clearTimeout(timer);

        childrenRef.current.removeEventListener("mousemove", showTooltip);
        childrenRef.current.removeEventListener("mouseleave", hideTooltip);
      }
    };
  }, [childrenRef, childrenRef.current, popperEl]);

  return (
    <TooltipWrapper
      ref={setPopperEl}
      style={styles.popper}
      {...attributes.popper}
      position={position}>
      {tooltipComponent ? tooltipComponent : tooltipLabel}
    </TooltipWrapper>
  );
};

Tooltip.propTypes = {
  childrenRef: PropTypes.oneOfType([PropTypes.object, PropTypes.node]).isRequired,
  tooltipLabel: PropTypes.node,
  tooltipComponent: PropTypes.node,
  placement: PropTypes.string,
  xShift: PropTypes.number
};

export default Tooltip;
